export const MOBILE_CONFIG = {
    // Feature Flag: Set to false to disable mobile UI globally
    ENABLE_MOBILE_UI: true, // ON for testing
};
